import { render } from "./Error401Page.vue?vue&type=template&id=4779274c&ts=true"
import script from "./Error401Page.vue?vue&type=script&lang=ts"
export * from "./Error401Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__